import {
  PrimitiveValueType,
  RecordsSearchFilterResponse,
  RowDataReducerAction,
} from "../../../../../types";

const CUSTOM_COA_GROUP_CODES: Map<string, string> = new Map([
  ["income_balance_group_code", "income_balance_group_description"],
  ["income_balance_sub_group_code", "income_balance_sub_group_description"],
  ["unit_analysis_group_code", "unit_analysis_group_description"],
]);

export const updateCOAGroupCodeDescription = (
  propertyKey: string,
  inputValue: PrimitiveValueType | undefined,
  response: RecordsSearchFilterResponse | undefined,
  dispatch: React.Dispatch<RowDataReducerAction>,
): void => {
  const targetDescriptionField = CUSTOM_COA_GROUP_CODES.get(propertyKey);
  if (!targetDescriptionField || !response || response.data.length === 0)
    return;
  const valueToUpdateForTargetDescriptionField =
    response.data.find((record) => record["group_code_id"] === inputValue)
      ?.group_code_description ?? null;
  dispatch({
    type: "UPDATE_FIELD",
    payload: {
      propertyKey: targetDescriptionField,
      newFieldValue: valueToUpdateForTargetDescriptionField as
        | string
        | boolean
        | null,
    },
  });
};
